import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import { postUploadedImage } from '../api';
import { toBase64All } from '../lib/toBase64';

export const usePostUploadedImage = (redirectUrl) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const { mutate: mutatePostUploadedImage } = useMutation({
    mutationKey: ['postUploadedImage'],
    mutationFn: (params) => postUploadedImage(params),
    onMutate: () => {
      setIsLoading(true);
    },
    onError: (e) => {
      alert(e.message);
      alert(e.name);
      alert(e.stack);
    },
    onSuccess: ({ result }) => {
      const SUCCESS = '0';
      const FAIL = '1';

      switch (result) {
        case SUCCESS:
          window.location.href = redirectUrl;
          break;
        case FAIL:
          setIsError(true);
          setIsLoading(false);
          break;
        default:
          break;
      }
    },
  });

  const handlePostUploadedImage = async (images, hspId, hspCd, acptNo, ptMpiKey, fileDataType) => {
    const fileList = await toBase64All(images.map((image) => image.file));
    mutatePostUploadedImage({
      hspId,
      hspCd,
      acptNo,
      fileList,
      ptMpiKey,
      fileDataType,
    });
  };
  return { handlePostUploadedImage, isLoading, isError, setIsError };
};
